<template>
    <div class="fill-height bg_auth">
        <v-window v-model="authStep" class="elevation-1 fill-height">
            <v-window-item value="login" id="#login" class="fill-height">
                <v-row class="d-flex align-center justify-center fill-height" style="height: 100%">
                    <v-col cols="10" md="4">
                        <div>
                            <div class="d-flex justify-center mb-4">
                                <img
                                    src="/img/bobbee_logo_3.png"
                                    :height="!$vuetify.display.mobile ? '100vh' : ''"
                                    :width="!$vuetify.display.mobile ? '' : '200vw'"
                                />
                            </div>
                            <v-form v-model="valid">
                                <div class="mb-2">
                                    <v-text-field
                                        label="E-mail"
                                        v-model="email"
                                        @keyup.enter="login"
                                        :error="error.length > 0"
                                        data-cy="login-email"
                                        id="login-email"
                                        :rules="[rules.notEmpty, rules.isEmail]"
                                    />
                                </div>
                                <div
                                    :key="SSOProviderRequestOnGoing + 1"
                                    style="min-height: 62px"
                                    class="d-flex align-center justify-center"
                                >
                                    <div v-if="SSOEnabled" class="text--secondary">
                                        <v-icon left size="small"> $fa-lock </v-icon>
                                        Connexion SAML SSO
                                    </div>
                                    <v-text-field
                                        v-model="password"
                                        v-else
                                        label="Mot de passe"
                                        :type="displayPassword ? 'text' : 'password'"
                                        @keyup.enter="login"
                                        :append-inner-icon="
                                            displayPassword ? '$oss-eye' : '$oss-eye-slash'
                                        "
                                        @click:appendInner="displayPassword = !displayPassword"
                                        :error="error.length > 0"
                                        :error-messages="error"
                                        data-cy="login-password"
                                        id="login-password"
                                        :rules="[rules.notEmpty]"
                                        :key="SSOProviderRequestOnGoing"
                                    />
                                </div>
                            </v-form>
                            <v-btn
                                class="elevation-0 rounded-lg mt-2"
                                block
                                :loading="loading"
                                @click="login"
                                data-cy="login-login"
                                size="large"
                            >
                                {{ SSOEnabled ? "Continuer" : "Se connecter" }}
                            </v-btn>
                            <div class="d-flex justify-space-between my-4">
                                <v-btn
                                    align-left
                                    href="mailto:support@bobbee.co"
                                    color="secondary"
                                    variant="text"
                                >
                                    Nous contacter
                                </v-btn>
                                <template v-if="ENABLE_COGNITO">
                                    <v-btn
                                        @click="authStep = 'forgotPassword'"
                                        color="secondary"
                                        variant="text"
                                    >
                                        Mot de passe oublié ?
                                    </v-btn>
                                </template>
                            </div>
                            <v-divider inset />
                            <div class="d-flex justify-end my-4">
                                <template v-if="DEV_MODE">
                                    <v-btn
                                        @click="register()"
                                        color="secondary"
                                        variant="text"
                                        class="block"
                                    >
                                        Créez un nouveau compte ?
                                    </v-btn>
                                </template>
                            </div>
                            <!-- <div class="d-flex justify-end my-4">
                                <v-btn
                                    @click="authStep = 'resendSignupEmail'"
                                    color="secondary"
                                    variant="outlined"
                                    class="block"
                                >
                                    Première connexion ?
                                </v-btn>
                            </div> -->
                            <!-- <div>
                                <div class="login-snackbar">
                                    <div class="d-flex">
                                        <div class="d-flex align-center px-3">
                                            <v-icon>$fa-info-circle</v-icon>
                                        </div>
                                        <div>
                                            <h3>Information</h3>
                                            <p>
                                                bobbee a récemment
                                                <b>modifié son système d'authentification</b>.
                                            </p>
                                            <p>
                                                Si vous n'avez pas encore
                                                <b>changé votre mot de passe</b>, veuillez le faire
                                                en suivant les instructions du
                                                <b
                                                    >mail que nous vous avons envoyé le 10
                                                    novembre</b
                                                >
                                                (vérifiez-vos spams).
                                            </p>
                                            <p>
                                                Si malgré tout vous ne trouvez pas ce mail,
                                                <a
                                                    style="text-decoration: underline"
                                                    @click="authStep = 'resendSignupEmail'"
                                                    >cliquez ici pour recevoir un nouveau mail</a
                                                >
                                                ou
                                                <a href="mailto:support@bobbee.co"
                                                    >contactez-nous ici</a
                                                >.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="resendSignupEmail">
                <v-form v-model="valid">
                    <v-row class="d-flex align-center justify-center" style="height: 100%">
                        <v-col cols="4">
                            <div>
                                <div class="d-flex justify-center mb-4">
                                    <img
                                        :src="bobbeeLogo"
                                        :height="!$vuetify.display.mobile ? '12vh' : ''"
                                        :width="!$vuetify.display.mobile ? '' : '22vw'"
                                    />
                                </div>
                                <v-text-field
                                    label="E-mail"
                                    v-model="email"
                                    @keyup.enter="resendSignupEmail"
                                    data-cy="login-forgotPassword-email"
                                    hide-details="auto"
                                    outlined
                                    class="mb-4"
                                    density="compact"
                                />
                                <v-btn
                                    class="elevation-0 rounded-lg"
                                    block
                                    :loading="loading"
                                    @click="resendSignupEmail"
                                    data-cy="resendSignupEmail"
                                    size="large"
                                >
                                    Renvoyer un email de réinitialisation de mot de passe
                                </v-btn>
                                <v-alert
                                    v-model="alertResendSignupEmail"
                                    :type="alertResendSignupEmailType"
                                    class="mt-4"
                                    outlined
                                    density="compact"
                                >
                                    {{ alertResendSignupEmailMessage }}
                                </v-alert>
                                <div class="d-flex justify-end mt-4">
                                    <v-btn
                                        @click="authStep = 'login'"
                                        color="secondary"
                                        variant="text"
                                    >
                                        Revenir à la page de connexion</v-btn
                                    >
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-window-item>
            <v-window-item value="forgotPassword" id="#forgotPassword" class="fill-height">
                <v-form v-model="valid">
                    <v-row class="d-flex align-center justify-center" style="height: 100%">
                        <v-col cols="4">
                            <div>
                                <div class="d-flex justify-center mb-4">
                                    <v-img
                                        src="/img/bobbee_logo_3.png"
                                        :height="!$vuetify.display.mobile ? '12vh' : ''"
                                        :width="!$vuetify.display.mobile ? '' : '22vw'"
                                    />
                                </div>
                                <p>Entrez l'adresse e-mail du compte</p>
                                <v-text-field
                                    label="E-mail"
                                    v-model="email"
                                    @keyup.enter="sendForgotPasswordEmail"
                                    :error="forgotPasswordError.length > 0"
                                    data-cy="login-forgotPassword-email"
                                    hide-details="auto"
                                    outlined
                                    class="mb-4 mt-4"
                                    density="compact"
                                />
                                <v-btn
                                    class="elevation-0 rounded-lg"
                                    block
                                    :loading="loading"
                                    @click="sendForgotPasswordEmail"
                                    data-cy="sendEmailForgotPassword"
                                    size="large"
                                >
                                    Envoyer un code de réinitialisation
                                </v-btn>
                                <div class="d-flex justify-end mt-4">
                                    <v-btn
                                        @click="authStep = 'login'"
                                        color="secondary"
                                        variant="text"
                                    >
                                        Revenir à la page de connexion
                                    </v-btn>
                                </div>
                                <v-divider class="mt-4" />
                                <v-alert
                                    v-model="alertForgotPassword"
                                    type="warning"
                                    class="mt-4"
                                    outlined
                                    density="compact"
                                >
                                    {{ forgotPasswordError }}
                                </v-alert>
                                <v-alert
                                    v-model="alertResendSignupEmail"
                                    :type="alertResendSignupEmailType"
                                    class="mt-4"
                                    outlined
                                    dense
                                >
                                    {{ alertResendSignupEmailMessage }}
                                </v-alert>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-window-item>
            <v-window-item value="verificationCode" id="#verificationCode" class="fill-height">
                <v-row class="d-flex align-center justify-center" style="height: 100%">
                    <v-col cols="4">
                        <div>
                            <div class="d-flex justify-center mb-4">
                                <img
                                    src="/img/bobbee_logo_3.png"
                                    :height="!$vuetify.display.mobile ? '12vh' : ''"
                                    :width="!$vuetify.display.mobile ? '' : '22vw'"
                                />
                            </div>
                            <p>Nous venons d'envoyer un code de vérification à {{ email }}</p>
                            <v-otp-input
                                v-model="otp"
                                length="6"
                                type="number"
                                class="mb-4 oss-otp-flat"
                            />
                            <v-btn
                                class="elevation-0 rounded-lg"
                                block
                                :loading="loading"
                                @click="authStep = 'changePassword'"
                                data-cy="sendEmailForgotPassword"
                                size="large"
                            >
                                Suivant
                            </v-btn>
                            <div class="d-flex justify-end mt-4">
                                <v-btn
                                    @click="authStep = 'forgotPassword'"
                                    color="secondary"
                                    variant="text"
                                >
                                    Retour</v-btn
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="changePassword" id="#changePassword" class="fill-height">
                <v-row class="d-flex align-center justify-center" style="height: 100%">
                    <v-col cols="4">
                        <div>
                            <div class="d-flex justify-center mb-4">
                                <img
                                    src="/img/bobbee_logo_3.png"
                                    :height="!$vuetify.display.mobile ? '12vh' : ''"
                                    :width="!$vuetify.display.mobile ? '' : '22vw'"
                                />
                            </div>
                            <p>Vous pouvez redéfinir un nouveau mot de passe ci-dessous</p>
                            <v-text-field
                                label="Nouveau mot de passe"
                                :type="displayPassword ? 'text' : 'password'"
                                v-model="password"
                                @keyup.enter="login"
                                :append-inner-icon="displayPassword ? '$oss-eye' : '$oss-eye-slash'"
                                :error="error.length > 0"
                                :error-messages="error"
                                hide-details="auto"
                                data-cy="login-change-password"
                                class="mb-4 mt-4"
                                outlined
                                density="compact"
                                @click:append-inner="displayPassword = !displayPassword"
                            />
                            <v-text-field
                                label="Confirmez votre nouveau mot de passe"
                                :type="displayPassword ? 'text' : 'password'"
                                v-model="confirmPassword"
                                @keyup.enter="login"
                                :append-inner-icon="displayPassword ? '$oss-eye' : '$oss-eye-slash'"
                                :error="error.length > 0"
                                :error-messages="error"
                                hide-details="auto"
                                data-cy="login-change-password-confirm"
                                class="mb-4"
                                outlined
                                density="compact"
                                @click:append-inner="displayPassword = !displayPassword"
                            />
                            <v-btn
                                class="elevation-0 rounded-lg"
                                block
                                :loading="loading"
                                @click="confirmForgotPassword()"
                                data-cy="sendEmailForgotPassword"
                                size="large"
                            >
                                Changer le mot de passe
                            </v-btn>
                            <div class="d-flex justify-end mt-4">
                                <v-btn @click="authStep = 'login'" color="secondary" variant="text">
                                    Revenir à la page de connexion</v-btn
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window>
    </div>
</template>

<script lang="ts">
import LOGGED_IN_USER from "../../graphql/auth/LoggedInUser.gql";
import RESEND_SIGNUP_EMAIL from "../../graphql/auth/ResendSignupEmail.gql";
import IS_FIRST_LOGIN from "../../graphql/auth/IsFirstLogin.gql";

import { isNavigationFailure } from "vue-router";

// import BobbeeLogoImport from "@/assets/img/bobbee_logo_3_CMJN_by_agiris.png";
import { AuthServices } from "@/services/auth.services";
import { emailPattern } from "@/services/emailServices";

import getEnv from "@/env";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { updateStoreUserAndSubUser } from "@/services/userServices";
import { Start } from "@/router";

const env = getEnv();

@Component
export class Login extends Vue {
    authStep = "login";
    email: string = "";
    otp: string = "";

    // bobbeeLogo = BobbeeLogoImport;
    password: string = "";
    confirmPassword: string = "";

    displayPassword: boolean = false;

    error: string = "";

    loading = false;

    valid: boolean = true;

    alertResendSignupEmail: boolean = false;
    alertResendSignupEmailType: "warning" | "success" | "error" | "info" = "warning";
    alertResendSignupEmailMessage: string = "";

    resendSignupError: string = "";

    forgotPasswordError: string = "";
    alertForgotPassword: boolean = false;

    SSOProviderRequestOnGoing = 0;

    userProviderMap = {};

    register() {
        this.$router.push({ name: "register" });
    }

    async login() {
        if (!this.valid) {
            return;
        }
        let loggedInUser;
        this.loading = true;
        await AuthServices.logout();
        if (this.SSOEnabled) {
            AuthServices.redirectToSSO(this.ssoProvider);
            return;
        }

        try {
            await AuthServices.login({
                email: this.email,
                password: this.password,
            });
            // this.$store.commit("updateConnectedWithCognito", true);
            const res = await this.$apollo.query({
                query: LOGGED_IN_USER,
            });
            loggedInUser = res?.data?.loggedInUser;
            if (loggedInUser) {
                const start = Start.getCreateStart();
                if (start) {
                    start.setLoggedInUser(res?.data?.loggedInUser || null);
                } else {
                    debugger;
                }

                await updateStoreUserAndSubUser(this.$apollo, this.$store, loggedInUser);
            } else {
                debugger;
            }
        } catch (e) {
            await setTimeout(() => {
                console.log("login error", e);
                this.error = "Vérifiez votre email et mot de passe";
                this.loading = false;
            }, 2000);
            return;
        }

        this.$store.commit("updateSubUserId", null);

        try {
            // Changed by Erwann to handle 403 redirect if no access to dashboard
            if (this.$route.query.from) {
                await this.$router.push(this.$route.query.from as string);
            } else if (loggedInUser?.profile?.homePage) {
                await this.$router.push({ name: loggedInUser.profile.homePage });
            } else {
                if (!loggedInUser?.profile?.configuration?.business?.dashboard) {
                    await this.$router.push({ name: "documents" });
                }
                await this.$router.push({ name: "dashboard" });
            }
        } catch (e) {
            if (!isNavigationFailure(e)) {
                console.error(e);
            }
        }
        this.loading = false;
    }

    beforeMount() {
        if (this.tokenCallback) {
            // AuthServices.setToken(this.tokenCallback);
            this.$router.replace({ name: "dashboard" });
        }
    }

    get ENABLE_COGNITO() {
        return env.ENABLE_COGNITO;
    }

    get DEV_MODE() {
        return env.DEV_MODE;
    }

    get ssoProvider() {
        return this.userProviderMap[this.email] || "";
    }

    SSOEnabled = false;

    get tokenCallback() {
        if (!this.$route.fullPath.includes("#access_token=")) return "";
        const result = this.$route.fullPath.split("#access_token=").at(-1)?.split("&")[0] || "";
        debugger;
        return result;
    }

    async resendSignupEmail() {
        let result = null;
        try {
            result = await this.$apollo.mutate({
                mutation: RESEND_SIGNUP_EMAIL,
                variables: {
                    email: this.email,
                },
            });
        } catch (e) {
            console.log("login error", e);
            this.error = "Vérifiez votre email";
            return;
        }
        if (result?.data?.resendSignupConfirmation?.success) {
            setTimeout(() => {
                this.authStep = "login";
            }, 3000);
            this.alertResendSignupEmailMessage =
                "Le mail a bien été envoyé, vous devriez le recevoir d'ici quelques secondes";
            this.alertResendSignupEmail = true;
            this.alertResendSignupEmailType = "success";
        } else {
            debugger;
            this.alertResendSignupEmailMessage =
                result?.data?.resendSignupConfirmation?.message || "Une erreur est survenue";
            this.alertResendSignupEmail = true;
            this.alertResendSignupEmailType = "warning";
        }
    }

    async sendForgotPasswordEmail() {
        let isFirstLogin = false;
        try {
            const query = await this.$apollo.query({
                query: IS_FIRST_LOGIN,
                variables: {
                    email: this.email,
                },
            });
            debugger;
            isFirstLogin = query.data?.isFirstLogin?.value
                ? (isFirstLogin = query.data.isFirstLogin.value)
                : false;
        } catch (e) {
            console.log("login error", e);
            this.error = "Vérifiez votre email";
            return;
        }
        if (isFirstLogin) {
            try {
                await this.resendSignupEmail();
            } catch (e) {
                debugger;
                this.forgotPasswordError =
                    "Error lors de l'envoie de l'email de réinitialisation de mot de passe. Veuillez réessayer plus tard. Si le problème persiste, contactez le support.";
                this.alertForgotPassword = true;
                return;
            }
            return;
        }
        try {
            await AuthServices.sendForgotPasswordEmail(this.email);
        } catch (e) {
            debugger;
        }
        this.alertForgotPassword = false;
        this.authStep = "verificationCode";
    }

    async confirmForgotPassword() {
        debugger;
        if (!this.password) {
            this.error = "Veuillez saisir un mot de passe";
            return;
        }
        if (this.password.length < 8) {
            this.error = "Le mot de passe doit contenir au moins 8 caractères";
            return;
        }
        if (!this.otp) {
            this.error = "Veuillez saisir le code de réinitialisation";
            return;
        }
        if (this.password === this.confirmPassword)
            try {
                await AuthServices.confirmForgotPassword(this.email, this.otp, this.password);
            } catch (e) {
                console.log("login error", e);
                this.error = "Vérifiez votre email";
                return;
            }
        this.authStep = "login";
    }

    @Watch("email")
    @Watch("password")
    reset() {
        this.error = "";
    }

    get rules() {
        return {
            isEmail: (value) => {
                return emailPattern.test(value) || "E-mail invalide";
            },
            notEmpty: (value) => {
                return !!value || "A remplir";
            },
        };
    }

    onFailure(googleUser) {
        console.log("failure", googleUser);
    }

    onSuccess(googleUser) {
        console.log("success", googleUser);
    }

    get renderParams() {
        return {
            width: 250,
            height: 50,
            longtitle: true,
        };
    }

    @Watch("email")
    async getSSOProvider() {
        // if (this.email) {
        //     console.log("change email", this.email);
        // }
        if (emailPattern.test(this.email)) {
            this.SSOProviderRequestOnGoing++;
            // check if email is already in map
            if (this.userProviderMap[this.email] !== undefined) {
                this.SSOEnabled = !!this.userProviderMap[this.email];
                this.SSOProviderRequestOnGoing--;
                return;
            }
            // check if email is email format
            // if (!emailPattern.test(this.email)) {
            //     this.SSOProviderRequestOnGoing--;
            //     this.SSOEnabled = false;
            //     return;
            // }

            const provider = await AuthServices.getSSOProviders(this.email);
            this.userProviderMap[this.email] = provider;
            this.SSOEnabled = !!provider;

            this.SSOProviderRequestOnGoing--;
        }
    }
}

export default toNative(Login);
</script>

<style scoped lang="scss">
.login-snackbar {
    background-color: rgba(250, 177, 41, 0.05);
    padding: 6px;
    padding-left: 0px;
    color: #000;
    border-left: #f9b129 solid 4px;
    border-radius: 4px;
}

.bg_auth {
    height: "100%";
    display: flex;
    flex-direction: column;
    justify-content: right;
    background-image: url("../../assets/img/bg_auth.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
}

.register_button {
    border: 2px solid #f9b129;
}
</style>
